import ReactComponent from '@/assets/icons/checkmark.svg?react';
import { CSSProperties } from 'react';

export interface UploadIconProps {
    color?: string;
    height?: number;
    style?: CSSProperties;
    className?: string;
    onClick?: () => void;
}

const Icon = ({
    color = '#000000',
    height = 20,
    style,
    className,
    onClick,
}: UploadIconProps) => {
    return (
        <ReactComponent
            height={height}
            stroke={color}
            style={{ minWidth: (height * 12) / 16, ...style }}
            className={className}
            onClick={onClick}
            // title="Checkmark"
        />
    );
};
export default Icon;
